import React from 'react';
import { LegalDoc } from '../components/LegalDoc';
import { PRIVACY, PRIVACY_NOTE, PRIVACY_UPDATED } from '../data/privacy';
export function Privacy() {
  return <LegalDoc title="Privacy Policy" updated={PRIVACY_UPDATED} sections={PRIVACY} note={PRIVACY_NOTE} data-id="element-668" data-mp="2whkj12rbmllx" />;
}